module.exports = __webpack_public_path__ + "img/schadensmeldungLogo.24cb74a4.svg";